import { render } from "./BuyUnits.vue?vue&type=template&id=7b3a2a11&scoped=true"
import script from "./BuyUnits.vue?vue&type=script&lang=js"
export * from "./BuyUnits.vue?vue&type=script&lang=js"

import "./BuyUnits.vue?vue&type=style&index=0&id=7b3a2a11&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3a2a11"]])

export default __exports__